<div class="section-header" mat-dialog-title>
  <mat-icon class="section-icon">{{ icon }}</mat-icon>
  <span class="section-title">{{ titleString }}</span>
  @if (table == 'player_data') {
    <app-video-link videoLink="importExportScene"></app-video-link>
  }
  @if (table == 'resources') {
    <app-video-link videoLink="importExportResource"></app-video-link>
  }
  <button mat-icon-button class="close-button" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <form>
    <div class="clipboard-actions">
      @if (isLoading) {
        <div class="loading-container">
          <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
        </div>
      }
      @if (!isLoading) {
        <div class="actions-container">
          <!-- Export Section -->
          <div class="action-card export-card">
            <div class="action-header">
              <mat-icon>file_upload</mat-icon>
              <h3>{{ 'ai.export' | transloco }}</h3>
            </div>
            <div class="action-info">
              <span class="info-label">{{ 'ai.selectedForExport' | transloco }}:</span>
              <span class="info-value">{{ this.totalSelected }}</span>
            </div>
            <button mat-raised-button color="primary" (click)="exportClick()" [disabled]="totalSelected === 0" class="action-button">
              <mat-icon class="rotateExport">call_merge</mat-icon>
              <span>{{ 'general.export' | transloco }}</span>
            </button>
          </div>

          <mat-divider vertical class="vertical-divider"></mat-divider>

          <!-- Import Section -->
          <div class="action-card import-card">
            <div class="action-header">
              <mat-icon>file_download</mat-icon>
              <h3>{{ 'ai.import' | transloco }}</h3>
            </div>
            <div class="action-info">
              <span class="info-label">{{ 'ai.availableForImport' | transloco }}:</span>
              <span class="info-value">{{ importSelected }}</span>
            </div>
            <button mat-raised-button color="accent" (click)="importClick()" [disabled]="importSelected === 0" class="action-button">
              <mat-icon class="rotateImport">call_merge</mat-icon>
              <span>{{ 'general.import' | transloco }}</span>
            </button>
          </div>
        </div>
      }
    </div>
  </form>
</div>

